"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgSelfPrimingFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M18.41 12.91l-.82-1.82 2.18-1a7 7 0 00-8.72 1L9.64 9.64a9 9 0 0112.72 0l1 1z" }),
        React.createElement("path", { d: "M16 2a14 14 0 1014 14A14 14 0 0016 2zm0 2a12 12 0 0111.94 10.84 4.49 4.49 0 01-1.27.75c-1.14.4-2.28.05-3.49-1.07l-.68-.63-.68.63c-1.78 1.64-3.36 1.64-5.14 0l-.68-.63-.68.63c-1.78 1.64-3.36 1.64-5.14 0l-.68-.63-.68.63C7.61 15.64 6.47 16 5.33 15.59a4.49 4.49 0 01-1.27-.75A12 12 0 0116 4zm0 21a8.94 8.94 0 01-6.36-2.64l-1-1 5-2.25.82 1.82-2.18 1A7 7 0 0021 21l1.41 1.41A8.94 8.94 0 0116 25z" })));
}
exports.default = SvgSelfPrimingFilled;
//# sourceMappingURL=SelfPrimingFilled.js.map